<template>
  <div class="container">
    <div class="product-list" v-show="productList.length > 0">
      <div class="list" v-for="(item,index) in productList" @click="goTaskDetail(item)" :key="index">
        <div class="product-img">
           <img :src="item.squarePicture" alt/>        </div>
        <div class="product-detail">
          <div class="pro-title">{{item.name}}</div>
          <div class="pro-text">
            <div class="pro-time">
              <div class>活动时间</div>
              <div class>起 {{item.activityStartTime}}</div>
              <div class>止 {{item.activityEndTime}}</div>
            </div>

            <img v-if="item.izAdopt == 1" src="../../../static/image/task/hadReceive.png" alt/>
          </div>
          <div class="pro-time count" v-if="item.needNumber>0"  style="margin-top: 10px;">
            <p style="margin-right: 10px;">需求款数</p>
            <p style="color: #000000;">{{item.needNumber}}</p>
          </div>
          <div class="pro-time count" v-if="item.receiveCount>0">
            <p style="margin-right: 10px;">领取人数</p>
            <p style="color: #000000;">{{item.receiveCount}}</p>
          </div>

        </div>
      </div>
    </div>
    <div v-show="productList.length == 0">
      <div style="width: 100%">
        <img style="width: 20%;margin-left: 40%;margin-top: 10%" src="../../../static/image/hallNoSubmit/nodata.png" alt/>
        <div style="width: 20%;height:40px;line-height:40px;margin-left: 40%;text-align: center;color:#CCCCCC;margin-top: 40px;">暂无数据</div>
      </div>
    </div>
    <!-- 引入分页器 -->
    <div class="PagePagination">
      <!-- <PagePagination ref="PageFrom" :pageIndex="pageIndex" :pageSize="pageSize"
                      :queryType="queryType" :val="val" :total="total"></PagePagination> -->
       <PagePagination ref="PageFrom" :pageIndex="pageIndex" :pageSize="pageSize"
                      :total="total"></PagePagination>
    </div>
  </div>
</template>

<script>
  import config from "../../api/config";
  import PagePagination from "../../components/pagePagination/pagePagination"; //引入分页器

  export default {
    name: "productList",
    props: ["region","queryType","val","lastId"],
    components:{
      PagePagination
    },
    data() {
      return {
        productList: [],
        pageIndex: 1,
        pageSize: 10,
        total:0,
        isTrue:false
      };
    },
    watch:{
      isTrue(n,o){
        console.log(n,o)
        this.isTrue = 0
      }
    },
    created() {
      this.getProductList();
    },
    methods: {
      changePageIndex(page) {
        this.pageIndex = page;
        this.isTrue = false
        setTimeout(() => {
          this.getProductList()
        }, 100)
      },
      //获取设计列表
      async getProductList() {
        try {
          if(this.isTrue){
            this.pageIndex = 1
          }
          let data = {
            lastId: this.lastId,
            pageIndex:this.pageIndex,
            pageSize: this.pageSize,
            queryType: this.queryType,
            val: this.val,
          }
          const res = await this.$http.getMissionList(data)
          if (res.code == 200) {
            if(res.result){
              res.result.records.forEach((item)=>{
                if(item.squarePicture!=null){
                  item.squarePicture = item.squarePicture.indexOf("http")>-1||item.squarePicture.indexOf("https")>-1?item.squarePicture:config.baseImgUrl+item.squarePicture
                }

              })
              this.productList = res.result.records;
              console.log(res.result.total)
              this.total = res.result.total
              this.$parent.changePageInfo(res.result.current,res.result.size,res.result.total)
            }else{
              this.productList = [];
            }
          } else {
            // this.$message(res.message);
          }
        } catch (e) {

          throw e
        }
      },
      //进入详情
      goTaskDetail(record) {
        this.$router.push({
          path: "/task/taskDetail",
          query: {id:record.id},
        });
      },
    },
  };
</script>


<style scoped>
  .container {
    width: 100%;
  }

  .product-list {
    width: 100%;
    display: flex;
    /*justify-content: space-between;*/
    flex-wrap: wrap;
    min-height: 760px;
  }

  .list {
    width: 18%;
    margin: 21px 1% 0 1%;
    display: inline-block;
    background: #ffffff;
    border-radius: 5px;
    height: 0%;
  }

  .product-img {
    width: 100%;
  }

  .product-img img {
    width: 100%;
    /*height: 220px;*/
  }

  .pro-icon {
    width: 46px !important;
    height: 22px !important;
    position: absolute;
  }

  .product-detail {
    padding: 0 8px 6px 8px;
  }

  .pro-title {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #3a3a3a;
    opacity: 1;
    margin: 15px 0 0 0;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }

  .pro-text {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .pro-text img {
    width: 50px;
    height: 50px;
    margin: 11px 0 0 0;
  }

  .pro-time {
    font-size: 8px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 14px;
    color: #9e9e9e;
    opacity: 1;
    margin: 15px 0 0 0;
  }
  .count{
    display: flex;
    margin: 0;
  }
  .submit {
    width: 62px;
    height: 24px;
    background: #dfb876;
    opacity: 1;
    border-radius: 14px;
    text-align: center;
    font-size: 11px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 23px;
    color: #ffffff;
    opacity: 1;
    margin: 31px 0 0 0;
  }
  .PagePagination {
    width: 63%;
    margin: 56px 18.5% 0px 18.5%;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/productList/productList.vue